import { YieldFetcher } from '../../types'

const stUSD = 'Angle Staked USDA::stUSD'
const stEur = 'Angle Staked EURA::stEUR'

/**
 * Angle savings (stUSD/USDA, stEUR/EURA) are deprecated. The APR exporter
 * (`exporter.angle.money/v2/savingsApr`) now 404s, so there is no live
 * source — the intrinsic yield is pinned to 0 rather than repeatedly
 * fetching a dead endpoint (which previously returned an HTML 404 that the
 * JSON parse choked on, leaving the value stale).
 */
export const angleFetcher: YieldFetcher = {
  label: 'ANGLE',
  fetch: async () => ({
    [stEur]: 0,
    // token-lists unifies every stEUR deployment to the bare `STEUR` group — emit there too.
    STEUR: 0,
    [stUSD]: 0,
  }),
}
